import { Sort } from "@saleor/types";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export enum StockOnHandSortField {
  customer = "customer",
  quantity = "quantity"
}

export function getSortStockOnHandField(
  sort: StockOnHandSortField
): StockOnHandSortField {
  return sort;
}

export const getSortQueryStockOnHandVariables = createGetSortQueryVariables(
  getSortStockOnHandField
);

export type StockOnHandSort = Sort<StockOnHandSortField>;
